import { writable } from 'svelte/store';

export type ToastVariant = 'success' | 'error' | 'info';

export interface ToastItem {
  id: number;
  message: string;
  variant: ToastVariant;
  duration: number;
}

function createToastStore() {
  const { subscribe, update } = writable<ToastItem[]>([]);
  let nextId = 1;

  function show(message: string, variant: ToastVariant = 'info', duration = 2400) {
    const id = nextId++;
    const toast: ToastItem = { id, message, variant, duration };

    update((items) => [...items, toast]);

    if (duration > 0) {
      window.setTimeout(() => {
        dismiss(id);
      }, duration);
    }

    return id;
  }

  function dismiss(id: number) {
    update((items) => items.filter((item) => item.id !== id));
  }

  return {
    subscribe,
    show,
    dismiss,
    success(message: string, duration?: number) {
      return show(message, 'success', duration);
    },
    error(message: string, duration?: number) {
      return show(message, 'error', duration);
    },
    info(message: string, duration?: number) {
      return show(message, 'info', duration);
    },
  };
}

export const toasts = createToastStore();
